import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Button,
  MenuItem,
  TextField,
  IconButton,
  Autocomplete,
  Checkbox
} from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import CloseIcon from "@mui/icons-material/Close";
import { validateRFCMo, validateRFCFs } from "../../app/util/util";
import { ErrorMessages } from "../../app/util/messages";

import DialogComponent from "../../app/common/DialogComponent";

import { RootStoreContext } from "../../app/store/root";

const initialState = {
  idDestino: 0,
  idProveedor: [],
  idProveedorListado: [],
  nombreEmpresaDestino: undefined,
  tipoPersona: undefined,
  rfc: undefined,
  direccion: undefined,
};

const FormDestinos = ({ data, onClose, onFinish }) => {
  const rootStore = useContext(RootStoreContext);
  const { entities, getAll } = rootStore.proveedorStore;

  /* UseStates */
  const [title, setTitle] = useState(undefined);
  const [disabled, setDisabled] = useState(true);
  const [model, setModel] = useState(initialState);

  const [errors, setErrors] = useState({
    idProveedor: false,
    nombreEmpresaDestino: false,
    tipoPersona: false,
    rfc: false,
    direccion: false,
  });

  const [messages, setMessages] = useState({
    idProveedor: undefined,
    nombreEmpresaDestino: undefined,
    tipoPersona: undefined,
    rfc: undefined,
    direccion: undefined,
  });

  const [showDialog, setShowDialog] = useState(false);
  const [typeAction, setTypeAction] = useState(undefined);
  const [messageDialog, setMessageDialog] = useState(undefined);
  /* End UseStates */

  useEffect(() => {
    getAll();
  }, []);

  useEffect(() => {
    setTitle(data != null ? "Edición de destino" : "Registro de destino");
    if (!data) {
    } else {
      setModel({ ...data });
    }
  }, [data]);

  /* Methods */
  const setValue = (key, value, opcionId = null) => {
    if (key === 'idProveedor' && value.length > 0) {
      if (value.map(a => a.id).includes('-1') && opcionId == '-1') {
        const newModel1 = {
          ...model, ...{
            [key]: [{
              id: "-1", nombreEmpresa: "", proveedores: "todos",
              correo: "", telefono: "", numCuentas: 0, codigoRegistro: "", idEstatus: 0, estatus: "", cantidadCuentas: 0
            }].concat(entities).map(a => { return { label: a.proveedores, id: a.id } })
          }
        };
        setModel({ ...newModel1 });
        onValidateAcceptButton();
        return
      }
      if (!value.map(a => a.id).includes('-1') && opcionId == '-1') {
        const newModel2 = { ...model, ...{ [key]: [] } };
        setModel({ ...newModel2 });
        onValidateAcceptButton();
        return
      }
      if (value.map(a => a.id).includes('-1') && opcionId != '-1') {
        value = value.filter(a => a.id != '-1').map(a => { return { id: a.id, label: a.label } })        
      }
    }
    const newModel = { ...model, ...{ [key]: value } };
    setModel({ ...newModel });
    onValidateAcceptButton();
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  const validationRFC = (e, typePerson = undefined) => {
    const value = e ? e.target.value : model?.rfc;
    const tipoPersona = typePerson ? typePerson : model?.tipoPersona;
    if (e) setValue("rfc", value);
    if (value.length > 0) {
      setError("rfc", false);
      setMessage("rfc", "");
      if (tipoPersona === "Moral") {
        if (!validateRFCMo(value)) {
          setError("rfc", true);
          setMessage("rfc", ErrorMessages.destino.RFCMoFormatIncorrect);
        }
      } else {
        if (!validateRFCFs(value)) {
          setError("rfc", true);
          setMessage("rfc", ErrorMessages.destino.RFCFsFormatIncorrect);
        }
      }
    } else {
      setError("rfc", true);
      setMessage("rfc", ErrorMessages.destino.RFCRequired);
    }
    onValidateAcceptButton();
  };
  const clearInitialState = () => {
    initialErrors();
    setModel({ ...initialState });
  };
  const initialErrors = () => {
    setErrors({
      ...errors,
      ...{
        idProveedor: true,
        nombreEmpresaDestino: true,
        tipoPersona: true,
        rfc: true,
        direccion: true,
      },
    });
    setMessages({
      ...messages,
      ...{
        nombreEmpresaDestino: ErrorMessages.destino.NamePartnerRequired,
        tipoPersona: ErrorMessages.destino.PersonTypeRequired,
        rfc: ErrorMessages.destino.RFCRequired,
        direccion: ErrorMessages.destino.AddressRequired,
      },
    });
    onValidateAcceptButton();
  };
  const validateModel = () => {
    const errors = [],
      objMessages = {};

    if (model.idProveedor.length == 0) {
      errors.push("idProveedor");
      Object.assign(objMessages, {
        idProveedor: ErrorMessages.destino.IdProveedorRequired,
      });
    }
    if (!model.nombreEmpresaDestino) {
      errors.push("nombreEmpresaDestino");
      Object.assign(objMessages, {
        nombreEmpresaDestino: ErrorMessages.destino.NamePartnerRequired,
      });
    }
    if (!model.tipoPersona) {
      errors.push("tipoPersona");
      Object.assign(objMessages, {
        tipoPersona: ErrorMessages.destino.PersonTypeRequired,
      });
    }
    if (!model.rfc) {
      errors.push("rfc");
      Object.assign(objMessages, {
        rfc: ErrorMessages.destino.RFCRequired,
      });
    }
    if (!model.direccion) {
      errors.push("direccion");
      Object.assign(objMessages, {
        direccion: ErrorMessages.destino.AddressRequired,
      });
    }

    if (errors.length > 0) {
      const objErrors = {};
      for (const error of errors) {
        Object.assign(objErrors, { [error]: true });
      }
      setErrors({
        ...errors,
        ...objErrors,
      });
      setMessages({
        ...messages,
        ...objMessages,
      });
    }

    onValidateAcceptButton();
    return errors.length <= 0;
  };
  const onValidateAcceptButton = () => {
    debugger    
    if (      
      !errors.nombreEmpresaDestino &&
      !errors.tipoPersona &&
      !errors.rfc &&
      !errors.direccion &&      
      model.nombreEmpresaDestino &&
      model.tipoPersona &&
      model.rfc &&
      model.direccion
    )
      setDisabled(false);
    else setDisabled(true);
  };
  /* End Methods */

  return (
    <div>
      <Grid container spacing={3} mb={2}>
        <Grid item xs>
          <h2 style={{ fontSize: 14 }}>
            <strong>{title}</strong>
          </h2>
        </Grid>
        <Grid item xs={6} />
        <Grid item xs>
          <div style={{ position: "relative" }}>
            <IconButton
              aria-label="close"
              onClick={() => {
                setTypeAction("close");
                setMessageDialog(
                  data == null
                    ? "¿Esta seguro que desea cerrar esta ventana? Si la cierra no se registrará el destino"
                    : "Si cierra esta ventana se perderá la información capturada. ¿Está seguro de que desea continuar?"
                );
                setShowDialog(true);
              }}
              style={{
                position: "absolute",
                top: "-10px",
                right: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </Grid>
      </Grid>
      <Box noValidate component="form">
        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6} lg={6}>
            {/*<Autocomplete
              size="small"
              margin="normal"
              required
              fullWidth
              id="selectProveedor"
              label="Proveedor"
              name="selectProveedor"

              multiple
              disableCloseOnSelect
              options={entities.map(a => { return { label: a.proveedores, id: a.id } })}
              value={valuesss}
              onChange={(_, newValue) => handleChange(newValue)}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={selected} />
                  {option.label}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params}
                  label="Hidden Users Proveedor"
                  placeholder="Name"
              variant="outlined" />)} />*/}
            <Autocomplete
              size="small"
              margin="normal"
              required
              fullWidth
              id="selectProveedor"
              label="Proveedor"
              name="selectProveedor"

              multiple
              options={[{
                id: "-1", nombreEmpresa: "", proveedores: "TODOS",
                correo: "", telefono: "", numCuentas: 0, codigoRegistro: "",
                idEstatus: 0, estatus: "", cantidadCuentas: 0
              }].concat(entities).map(a => { return { label: a.proveedores, id: a.id } })}
              disableCloseOnSelect
              getOptionLabel={(option) => option.label}
              value={model?.idProveedor}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, newValue, reason, details) => {                
                setError("idProveedor", newValue?.length <= 0);
                setValue('idProveedor', newValue, details?.option?.id)                
                setMessage(
                  "idProveedor", newValue?.length <= 0 ? ErrorMessages.destino.IdProveedorRequired : "");
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
              renderInput={(params) => <TextField
                error={errors.idProveedor}
                helperText={messages.idProveedor}
                size="small" margin="normal" {...params} label="Proveedor" />}
            />

            {/*<Autocomplete
              multiple
              disableCloseOnSelect
              size="small"
              margin="normal"
              required
              fullWidth
              id="selectProveedor"
              label="Proveedor"
              name="selectProveedor"
              onChange={(event, newValue) => {
                console.log('newValue ', newValue)
                setValue('idProveedor', newValue?.map(a => a.id))
                //setError("idProveedor", newValue?.map(a => a.id).length <= 0 <= 0);
                //setMessage("idProveedor", newValue?.map(a => a.id).length <= 0 ? ErrorMessages.destino.IdProveedorRequired : "");
              }}
              options={entities.map(a => { return { label: a.proveedores, id: a.id } })}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label + ' selected = ' + selected}
                </li>
              )}
              renderInput={(params) => <TextField size="small" margin="normal" {...params} label="Proveedor" />}
            >
              </Autocomplete>*/}

            {/*<TextField
              size="small"
              margin="normal"
              select
              required
              fullWidth
              id="selectProveedor"
              label="Proveedor"
              error={errors.idProveedor}
              value={model?.idProveedor || ""}
              helperText={messages.idProveedor}
              onChange={(e) => {
                setValue("idProveedor", e.target.value);
                setError("idProveedor", e.target.value.length <= 0);
                setMessage(
                  "idProveedor",
                  e.target.value.length <= 0
                    ? ErrorMessages.destino.IdProveedorRequired
                    : ""
                );
              }}
            >
              {entities.map((x, index) => (
                <MenuItem key={index} value={x.id}>
                  {x.proveedores}
                </MenuItem>
              ))}
            </TextField>*/}
          </Grid>
          <Grid item xs={6} lg={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="name"
              label="Nombre de la empresa de destino"
              name="name"
              inputProps={{ maxLength: 50 }}
              value={model?.nombreEmpresaDestino || ""}
              error={errors.nombreEmpresaDestino}
              helperText={messages.nombreEmpresaDestino}
              onChange={(e) => {
                setValue("nombreEmpresaDestino", e.target.value);
                setError("nombreEmpresaDestino", e.target.value.length <= 0);
                setMessage(
                  "nombreEmpresaDestino",
                  e.target.value.length <= 0
                    ? ErrorMessages.destino.NamePartnerRequired
                    : ""
                );
              }}
            />
          </Grid>
          <Grid item xs={6} lg={6}>
            <TextField
              size="small"
              margin="normal"
              select
              required
              fullWidth
              id="selectTipoDePersona"
              label="Tipo de persona"
              error={errors.tipoPersona}
              value={model?.tipoPersona || ""}
              helperText={messages.tipoPersona}
              onChange={(e) => {
                setValue("tipoPersona", e.target.value);
                setError("tipoPersona", e.target.value.length <= 0);
                setMessage(
                  "tipoPersona",
                  e.target.value.length <= 0
                    ? ErrorMessages.destino.PersonTypeRequired
                    : ""
                );
                setTimeout(() => {
                  validationRFC(undefined, e.target.value);
                }, 300);
              }}
            >
              <MenuItem value="Moral">Moral</MenuItem>
              <MenuItem value="Físico">Físico</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} lg={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="rfc"
              label="RFC"
              name="rfc"
              error={errors.rfc}
              value={model.rfc || ""}
              helperText={messages.rfc}
              onChange={validationRFC}
            />
          </Grid>
          <Grid item xs={6} lg={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="direccion"
              label="Dirección"
              name="direccion"
              multiline
              rows={4}
              inputProps={{ maxLength: 100 }}
              error={errors.direccion}
              value={model?.direccion || ""}
              helperText={messages.direccion}
              onChange={(e) => {
                setValue("direccion", e.target.value);
                setError("direccion", e.target.value.length <= 0);
                setMessage(
                  "direccion",
                  e.target.value.length <= 0
                    ? ErrorMessages.destino.AddressRequired
                    : ""
                );
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        mt={2}
      >
        <Button
          onClick={() => {
            setTypeAction("clear");
            setMessageDialog(
              "Se eliminará toda la información capturada. ¿Está seguro que desea continuar?"
            );
            setShowDialog(true);
          }}
          variant="contained"
          color="secondary"
          sx={{ color: "#fff" }}
        >
          Limpiar
        </Button>
        <Button
          type="submit"
          onClick={() => {
            setTypeAction("continue");
            setMessageDialog(
              data == null
                ? "¿Todos los datos son correctos?"
                : "¿Seguro que quiere guardar estos cambios?"
            );
            setShowDialog(true);
          }}
          variant="contained"
          disabled={disabled || model.idProveedor?.length <= 0}
          style={{ marginLeft: 10 }}
        >
          Aceptar
        </Button>
      </Grid>
      <DialogComponent
        Open={showDialog}
        Message={messageDialog}
        OnClose={() => setShowDialog(false)}
        OnAccept={() => {
          if (typeAction === "clear") {
            clearInitialState();
          } else if (typeAction === "continue") {
            if (validateModel()) {
              onFinish(model);
            }
          } else if (typeAction === "close") {
            onClose();
          }
          setShowDialog(false);
        }}
      />
    </div>
  );
};

export default observer(FormDestinos);
